import React from "react";
import "./oneInvoice.scss";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { BsBackspaceFill } from "react-icons/bs";
import { GrDocumentPdf } from "react-icons/gr";
import qrCodeGenerator from "qrcode-generator";
import QRCode from "qrcode.react";

export class Main extends React.Component {
    state = {
        customInvoiceFile: "",
        oneInvoiceFormater: "",
    };

    componentDidMount = async () => {
        console.log("KN");
        if (!this.props.generickiPredlozakRacuna) {
            await this.setState({
                customInvoiceFile: this.props.customInvoiceFile,
            });

            let element = document.getElementById("oneInvoicePDF");
            var SampleText;
            var NewText;

            if (this.state.customInvoiceFile.indexOf("{client_name}") !== -1) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{client_name}",
                    this.props.oneInvoice.client_name
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (
                this.state.customInvoiceFile.indexOf("{client_address}") !== -1
            ) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{client_address}",
                    this.props.oneInvoice.client_address
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (this.state.customInvoiceFile.indexOf("{client_oib}") !== -1) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{client_oib}",
                    this.props.oneInvoice.client_oib
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (this.state.customInvoiceFile.indexOf("{invoice_date}") !== -1) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{invoice_date}",
                    this.props.oneInvoice.invoice_date
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (
                this.state.customInvoiceFile.indexOf(
                    "{invoice_business_premises_label}"
                ) !== -1
            ) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{invoice_business_premises_label}",
                    this.props.oneInvoice.invoice_business_premises_label
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (
                this.state.customInvoiceFile.indexOf(
                    "{invoicebusinesspremises}"
                ) !== -1
            ) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{invoicebusinesspremises}",
                    this.props.oneInvoice.invoicebusinesspremises
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (
                this.state.customInvoiceFile.indexOf(
                    "{invoice_billing_device_isu}"
                ) !== -1
            ) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{invoice_billing_device_isu}",
                    this.props.oneInvoice.invoice_billing_device_isu
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (this.state.customInvoiceFile.indexOf("{ZKI}") !== -1) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{ZKI}",
                    this.props.oneInvoice.ZKI
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (this.state.customInvoiceFile.indexOf("{JIR}") !== -1) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{JIR}",
                    this.props.oneInvoice.JIR
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (this.state.customInvoiceFile.indexOf("{invoice_no}") !== -1) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{invoice_no}",
                    this.props.oneInvoice.invoice_no
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (this.state.customInvoiceFile.indexOf("{invoice_no}") !== -1) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{invoice_no}",
                    this.props.oneInvoice.invoice_no
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (
                this.state.customInvoiceFile.indexOf("{invoice_amount}") !== -1
            ) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{invoice_amount}",
                    this.props.oneInvoice.invoice_amount
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (
                this.state.customInvoiceFile.indexOf("{in_VAT_system}") !== -1
            ) {
                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll(
                    "{in_VAT_system}",
                    this.props.oneInvoice.in_VAT_system
                );
                await this.setState({ customInvoiceFile: NewText });
            }
            if (this.state.customInvoiceFile.indexOf("{qrCode}") !== -1) {
                let qrString = await this.qrString(this.props.oneInvoice);

                var typeNumber = 0;
                var errorCorrectionLevel = "L";
                var qr = qrCodeGenerator(typeNumber, errorCorrectionLevel);
                qr.addData(qrString);
                qr.make();

                SampleText = this.state.customInvoiceFile;
                NewText = SampleText.replaceAll("{qrCode}", qr.createImgTag(4));
                await this.setState({ customInvoiceFile: NewText });
            }

            if (
                this.state.customInvoiceFile.indexOf("{#tax}") !== -1 &&
                this.state.customInvoiceFile.indexOf("{/tax}") !== -1
            ) {
                var pocetak = this.state.customInvoiceFile.indexOf("{#tax}");
                var kraj = this.state.customInvoiceFile.indexOf("{/tax}");

                let HTMLtax = this.state.customInvoiceFile.substr(
                    pocetak + 11,
                    kraj - 4 - pocetak - 11
                );

                // check if table
                if (HTMLtax.indexOf("table") !== -1) {
                    let brojRedakaTablice =
                        (HTMLtax.split("tr").length - 1) / 2; //djelit sa 2 jer jedan red ima open and close tag

                    let redakKojiJeTax = 0; // 0 = tax varaiables not in table
                    let i = 1;
                    let pocetakRetka;
                    let krajRetka;
                    let HTMLredak;
                    let taxesHTMLafterLoop = "";
                    // loop trough each row
                    if (redakKojiJeTax === 0) {
                        for (i; i <= brojRedakaTablice; i++) {
                            pocetakRetka =
                                this.getPosition(
                                    this.state.customInvoiceFile,
                                    "tr",
                                    i * 2 - 1
                                ) - 1;
                            krajRetka =
                                this.getPosition(
                                    this.state.customInvoiceFile,
                                    "tr",
                                    i * 2
                                ) + 4;
                            HTMLredak = this.state.customInvoiceFile.substr(
                                pocetakRetka,
                                krajRetka - pocetakRetka
                            );
                            console.log("HTMLredak");
                            console.log(HTMLredak);
                            if (
                                HTMLredak.indexOf("{tax_rate}") !== -1 ||
                                HTMLredak.indexOf("{tax_base}") !== -1 ||
                                HTMLredak.indexOf("{tax_amount}") !== -1
                            ) {
                                console.log("nasao na retku broj: ", i);
                                redakKojiJeTax = i;
                            }
                        }
                    }
                    // if redakKojiJeTax = 0 there is no variables so stop
                    if (redakKojiJeTax !== 0) {
                        //get redak koji ima varijable
                        pocetakRetka =
                            this.getPosition(
                                this.state.customInvoiceFile,
                                "tr",
                                redakKojiJeTax * 2 - 1
                            ) - 1;
                        krajRetka =
                            this.getPosition(
                                this.state.customInvoiceFile,
                                "tr",
                                redakKojiJeTax * 2
                            ) + 4;
                        HTMLredak = this.state.customInvoiceFile.substr(
                            pocetakRetka,
                            krajRetka - pocetakRetka
                        );

                        //loop trough all taxes
                        this.props.oneInvoice.tax.map((data, index) => {
                            let noviRedak = HTMLredak;
                            if (noviRedak.indexOf("{tax_rate}") !== -1) {
                                noviRedak = noviRedak.replaceAll(
                                    "{tax_rate}",
                                    data.tax_rate
                                );
                            }
                            if (noviRedak.indexOf("{tax_base}") !== -1) {
                                noviRedak = noviRedak.replaceAll(
                                    "{tax_base}",
                                    data.tax_base
                                );
                            }
                            if (noviRedak.indexOf("{tax_amount}") !== -1) {
                                noviRedak = noviRedak.replaceAll(
                                    "{tax_amount}",
                                    data.tax_amount
                                );
                            }
                            taxesHTMLafterLoop +=
                                taxesHTMLafterLoop + noviRedak;

                            return null;
                        });

                        //rascjepaj string na 2 djela i ubaci fromatirani text
                        pocetakRetka =
                            this.getPosition(
                                this.state.customInvoiceFile,
                                "tr",
                                redakKojiJeTax * 2 - 1
                            ) - 1;
                        krajRetka =
                            this.getPosition(
                                this.state.customInvoiceFile,
                                "tr",
                                redakKojiJeTax * 2
                            ) + 4;
                        let pocetakStringa =
                            this.state.customInvoiceFile.substr(
                                0,
                                pocetakRetka
                            );
                        let krajStringa = this.state.customInvoiceFile.substr(
                            krajRetka,
                            this.state.customInvoiceFile.length
                        );
                        let konacniHTML =
                            pocetakStringa + taxesHTMLafterLoop + krajStringa;

                        //replace occurance of #tax and /tax
                        konacniHTML = konacniHTML.replaceAll("{#tax}", "");
                        konacniHTML = konacniHTML.replaceAll("{/tax}", "");
                        this.setState({ customInvoiceFile: konacniHTML });
                    }
                }
                //ako nije tablica
                else {
                    var taxesHTMLafterLoop = "";

                    this.props.oneInvoice.tax.map((data, index) => {
                        let noviRedak = HTMLtax;
                        if (noviRedak.indexOf("{tax_rate}") !== -1) {
                            noviRedak = noviRedak.replaceAll(
                                "{tax_rate}",
                                data.tax_rate
                            );
                        }
                        if (noviRedak.indexOf("{tax_base}") !== -1) {
                            noviRedak = noviRedak.replaceAll(
                                "{tax_base}",
                                data.tax_base
                            );
                        }
                        if (noviRedak.indexOf("{tax_amount}") !== -1) {
                            noviRedak = noviRedak.replaceAll(
                                "{tax_amount}",
                                data.tax_amount
                            );
                        }
                        taxesHTMLafterLoop = taxesHTMLafterLoop + noviRedak;

                        return null;
                    });
                    // makni #tax i /tax iz stringa
                    let odrezaniString = this.state.customInvoiceFile.substr(
                        pocetak,
                        kraj - pocetak
                    );
                    console.log("odrezaniString: ", odrezaniString);
                    let carouselLeftZnakIzaTax = odrezaniString.indexOf("<");
                    let carouselRightZnakIzaTax = odrezaniString.indexOf(">");
                    let znakizaTaxElementa = odrezaniString.substr(
                        carouselLeftZnakIzaTax,
                        carouselRightZnakIzaTax - carouselLeftZnakIzaTax + 1
                    );
                    let znakIspredTaxElementa = znakizaTaxElementa.replace(
                        "/",
                        ""
                    );
                    console.log("pocetak: ", pocetak);
                    console.log("kraj: ", kraj);
                    console.log("znakizaTaxElementa: ", znakizaTaxElementa);
                    console.log(
                        "znakIspredTaxElementa: ",
                        znakIspredTaxElementa
                    );

                    let prviDio = this.state.customInvoiceFile.substr(
                        0,
                        pocetak + "{#tax}".length + znakizaTaxElementa.length
                    );
                    console.log(prviDio);
                    let treciDio = this.state.customInvoiceFile.substr(
                        kraj - znakIspredTaxElementa.length,
                        this.state.customInvoiceFile.length
                    );
                    console.log(treciDio);

                    let konacniHTML = prviDio + taxesHTMLafterLoop + treciDio;

                    konacniHTML = konacniHTML.replace(
                        znakIspredTaxElementa + "{#tax}" + znakizaTaxElementa,
                        ""
                    );
                    konacniHTML = konacniHTML.replace(
                        znakIspredTaxElementa + "{/tax}" + znakizaTaxElementa,
                        ""
                    );
                    console.log(konacniHTML);

                    this.setState({
                        customInvoiceFile: konacniHTML,
                    });
                }
            }

            //items checker
            if (
                this.state.customInvoiceFile.indexOf("{#items}") !== -1 &&
                this.state.customInvoiceFile.indexOf("{/items}") !== -1
            ) {
                pocetak = this.state.customInvoiceFile.indexOf("{#items}");
                kraj = this.state.customInvoiceFile.indexOf("{/items}");

                let HTMLitem = this.state.customInvoiceFile.substr(
                    pocetak + 12,
                    kraj - 4 - pocetak - 11
                );
                console.log(HTMLitem);
                let itemsHTMLafterLoop = "";

                // check if table
                if (HTMLitem.indexOf("table") !== -1) {
                    let brojRedakaTablice =
                        (HTMLitem.split("tr").length - 1) / 2; //djelit sa 2 jer jedan red ima open and close tag

                    let redakKojiJeArticle = 0; // 0 = tax varaiables not in table
                    let i = 1;
                    let pocetakRetka;
                    let krajRetka;
                    let HTMLredak;
                    // loop trough each row
                    if (redakKojiJeArticle === 0) {
                        for (i; i <= brojRedakaTablice; i++) {
                            console.log(i);
                            pocetakRetka =
                                this.getPosition(
                                    this.state.customInvoiceFile,
                                    "tr",
                                    i * 2 - 1
                                ) - 1;
                            krajRetka =
                                this.getPosition(
                                    this.state.customInvoiceFile,
                                    "tr",
                                    i * 2
                                ) + 4;
                            HTMLredak = this.state.customInvoiceFile.substr(
                                pocetakRetka,
                                krajRetka - pocetakRetka
                            );
                            console.log("HTMLredak");
                            console.log(HTMLredak);
                            if (
                                HTMLredak.indexOf("{article}") !== -1 ||
                                HTMLredak.indexOf("{quantity}") !== -1 ||
                                HTMLredak.indexOf(
                                    "{single_unit_retail_price}"
                                ) !== -1 ||
                                HTMLredak.indexOf("{total_amount}") !== -1 ||
                                HTMLredak.indexOf("{item_tax_rate}") !== -1 ||
                                HTMLredak.indexOf("{item_tax_amount}") !== -1
                            ) {
                                console.log("nasao na retku broj: ", i);
                                redakKojiJeArticle = i;
                            }
                        }
                    }
                    // if redakKojiJeArticle = 0 there is no variables so stop
                    if (redakKojiJeArticle !== 0) {
                        //get redak koji ima varijable
                        pocetakRetka =
                            this.getPosition(
                                this.state.customInvoiceFile,
                                "tr",
                                redakKojiJeArticle * 2 - 1
                            ) - 1;
                        krajRetka =
                            this.getPosition(
                                this.state.customInvoiceFile,
                                "tr",
                                redakKojiJeArticle * 2
                            ) + 4;
                        HTMLredak = this.state.customInvoiceFile.substr(
                            pocetakRetka,
                            krajRetka - pocetakRetka
                        );

                        //loop trough all items
                        this.props.oneInvoice.items.map((data, index) => {
                            console.log(index);
                            let noviRedak = HTMLredak;
                            if (noviRedak.indexOf("{article}") !== -1) {
                                noviRedak = noviRedak.replaceAll(
                                    "{article}",
                                    data.article
                                );
                            }
                            if (noviRedak.indexOf("{quantity}") !== -1) {
                                noviRedak = noviRedak.replaceAll(
                                    "{quantity}",
                                    data.quantity
                                );
                            }
                            if (
                                noviRedak.indexOf(
                                    "{single_unit_retail_price}"
                                ) !== -1
                            ) {
                                noviRedak = noviRedak.replaceAll(
                                    "{single_unit_retail_price}",
                                    data.single_unit_retail_price
                                );
                            }
                            if (noviRedak.indexOf("{total_amount}") !== -1) {
                                noviRedak = noviRedak.replaceAll(
                                    "{total_amount}",
                                    data.total_amount
                                );
                            }
                            if (noviRedak.indexOf("{item_tax_rate}") !== -1) {
                                noviRedak = noviRedak.replaceAll(
                                    "{item_tax_rate}",
                                    data.tax_rate
                                );
                            }
                            if (noviRedak.indexOf("{item_tax_amount}") !== -1) {
                                noviRedak = noviRedak.replaceAll(
                                    "{item_tax_amount}",
                                    data.tax_amount
                                );
                            }
                            if (noviRedak.indexOf("{base_price}") !== -1) {
                                noviRedak = noviRedak.replaceAll(
                                    "{base_price}",
                                    data.base_price
                                );
                            }

                            itemsHTMLafterLoop = itemsHTMLafterLoop + noviRedak;

                            return null;
                        });

                        //rascjepaj string na 2 djela i ubaci fromatirani text
                        pocetakRetka =
                            this.getPosition(
                                this.state.customInvoiceFile,
                                "tr",
                                redakKojiJeArticle * 2 - 1
                            ) - 1;
                        krajRetka =
                            this.getPosition(
                                this.state.customInvoiceFile,
                                "tr",
                                redakKojiJeArticle * 2
                            ) + 4;
                        let pocetakStringa =
                            this.state.customInvoiceFile.substr(
                                0,
                                pocetakRetka
                            );
                        let krajStringa = this.state.customInvoiceFile.substr(
                            krajRetka,
                            this.state.customInvoiceFile.length
                        );
                        let konacniHTML =
                            pocetakStringa + itemsHTMLafterLoop + krajStringa;
                        console.log(konacniHTML);
                        //replace occurance of #tax and /tax
                        konacniHTML = konacniHTML.replaceAll("{#items}", "");
                        console.log(konacniHTML);
                        konacniHTML = konacniHTML.replaceAll("{/items}", "");
                        console.log(konacniHTML);
                        this.setState({ customInvoiceFile: konacniHTML });
                    }
                }
                //ako nije tablica
                else {
                    itemsHTMLafterLoop = "";

                    //loop trough all items
                    this.props.oneInvoice.items.map((data, index) => {
                        let noviRedak = HTMLitem;
                        if (noviRedak.indexOf("{article}") !== -1) {
                            noviRedak = noviRedak.replaceAll(
                                "{article}",
                                data.article
                            );
                        }
                        if (noviRedak.indexOf("{quantity}") !== -1) {
                            noviRedak = noviRedak.replaceAll(
                                "{quantity}",
                                data.quantity
                            );
                        }
                        if (
                            noviRedak.indexOf("{single_unit_retail_price}") !==
                            -1
                        ) {
                            noviRedak = noviRedak.replaceAll(
                                "{single_unit_retail_price}",
                                data.single_unit_retail_price
                            );
                        }
                        if (noviRedak.indexOf("{total_amount}") !== -1) {
                            noviRedak = noviRedak.replaceAll(
                                "{total_amount}",
                                data.total_amount
                            );
                        }
                        if (noviRedak.indexOf("{item_tax_rate}") !== -1) {
                            noviRedak = noviRedak.replaceAll(
                                "{item_tax_rate}",
                                data.tax_rate
                            );
                        }
                        if (noviRedak.indexOf("{item_tax_amount}") !== -1) {
                            noviRedak = noviRedak.replaceAll(
                                "{item_tax_amount}",
                                data.tax_amount
                            );
                        }
                        if (noviRedak.indexOf("{base_price}") !== -1) {
                            noviRedak = noviRedak.replaceAll(
                                "{base_price}",
                                data.base_price
                            );
                        }

                        itemsHTMLafterLoop = itemsHTMLafterLoop + noviRedak;
                        return null;
                    });
                    // makni #tax i /tax iz stringa
                    let odrezaniString = this.state.customInvoiceFile.substr(
                        pocetak,
                        kraj - pocetak
                    );
                    let carouselLeftZnakIzaItems = odrezaniString.indexOf("<");
                    let carouselRightZnakIzaItems = odrezaniString.indexOf(">");
                    let znakizaItemsElementa = odrezaniString.substr(
                        carouselLeftZnakIzaItems,
                        carouselRightZnakIzaItems - carouselLeftZnakIzaItems + 1
                    );
                    let znakIspredItemsElementa = znakizaItemsElementa.replace(
                        "/",
                        ""
                    );
                    let prviDio = this.state.customInvoiceFile.substr(
                        0,
                        pocetak +
                            "{#items}".length +
                            znakizaItemsElementa.length +
                            1
                    );
                    let treciDio = this.state.customInvoiceFile.substr(
                        kraj - znakIspredItemsElementa.length,
                        this.state.customInvoiceFile.length
                    );
                    let konacniHTML = prviDio + itemsHTMLafterLoop + treciDio;
                    konacniHTML = konacniHTML.replace(
                        znakIspredItemsElementa +
                            "{#items}" +
                            znakizaItemsElementa,
                        ""
                    );
                    konacniHTML = konacniHTML.replace(
                        znakIspredItemsElementa +
                            "{/items}" +
                            znakizaItemsElementa,
                        ""
                    );

                    this.setState({
                        customInvoiceFile: konacniHTML,
                    });
                }
            }

            element.innerHTML = this.state.customInvoiceFile;
        }
    };

    getPosition(string, subString, index) {
        return string.split(subString, index).join(subString).length;
    }

    qrCode(racun) {
        let total = this.qrString(racun);

        return <QRCode value={total} renderAs={"svg"} />;
    }

    qrString(racun) {
        const zki = racun.ZKI;
        let datum = racun.invoice_date.split(" ")[0];
        let dan = datum.split(".")[0];
        let mjesec = datum.split(".")[1];
        let godina = datum.split(".")[2];
        let vrijeme = racun.invoice_date.split(" ")[1];
        let sati = vrijeme.split(":")[0];
        let minute = vrijeme.split(":")[1];
        let customDatum = godina + mjesec + dan + "_" + sati + minute;

        const poreznaURL = "https://porezna.gov.hr/rn?";
        const iznos = racun.invoice_amount + "00";

        let total =
            poreznaURL +
            "zki=" +
            zki +
            "&datv=" +
            customDatum +
            "&izn=" +
            iznos;

        return total;
    }

    saveToPDF(racunNo) {
        const input = document.getElementById("oneInvoicePDF");

        console.log(input);
        document.getElementById("main_racuni").classList.add("hide-scrollbar");

        html2canvas(input, {}).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF();
            pdf.addImage(imgData, "PNG", -5, 0);
            pdf.save(
                this.props.oneInvoice.invoice_no +
                    "/" +
                    this.props.oneInvoice.invoice_business_premises_label +
                    "/" +
                    this.props.oneInvoice.invoice_billing_device_isu +
                    ".pdf"
            );
        });
    }

    roundToTwo(num) {
        return +(Math.round(num + "e+2") + "e-2");
    }

    render() {
        return (
            <div>
                <div>
                    <div className="oneInvoicePDF A4">
                        {!this.props.generickiPredlozakRacuna ? (
                            <div
                                className="body page"
                                id="oneInvoicePDF"
                                //dangerouslySetInnerHTML={createHTML()}
                            />
                        ) : (
                            <div className="body page" id="oneInvoicePDF">
                                <div className="text_firma">
                                    {this.props.oneInvoice.client_name}
                                </div>
                                <div className="text_firma_mala">
                                    {this.props.oneInvoice.client_address}
                                </div>
                                <div className="text_firma_mala">
                                    OIB: {this.props.oneInvoice.client_oib}
                                </div>

                                <div style={{ marginBottom: "40px" }} />

                                <div className="text">
                                    Adresa prostora:{" "}
                                    {
                                        this.props.oneInvoice
                                            .invoicebusinesspremises
                                    }
                                </div>
                                <div className="text">
                                    Poslovni prostor:{" "}
                                    {
                                        this.props.oneInvoice
                                            .invoice_business_premises_label
                                    }
                                </div>
                                <div className="text">
                                    Uređaj ISU:{" "}
                                    {
                                        this.props.oneInvoice
                                            .invoice_billing_device_isu
                                    }
                                </div>
                                <div className="text">
                                    Račun br: {this.props.oneInvoice.invoice_no}
                                    /
                                    {
                                        this.props.oneInvoice
                                            .invoice_business_premises_label
                                    }
                                    /
                                    {
                                        this.props.oneInvoice
                                            .invoice_billing_device_isu
                                    }
                                </div>
                                <div className="text">
                                    Nadnevak:{" "}
                                    {this.props.oneInvoice.invoice_date}
                                </div>
                                <div className="text">
                                    Sredstvo plaćanja:{" "}
                                    {this.props.oneInvoice.means_of_payment}
                                </div>

                                <div style={{ marginBottom: "20px" }} />

                                {/* items */}
                                <table className="table">
                                    <thead className="tableRow">
                                        <tr>
                                            <th
                                                style={{
                                                    width: "50%",
                                                    textAlign: "left",
                                                }}
                                                className="tableCellHeader"
                                            >
                                                Naziv Artikla
                                            </th>
                                            <th
                                                style={{
                                                    width: "20%",
                                                    textAlign: "right",
                                                }}
                                                className="tableCellHeader"
                                            >
                                                Cijena
                                            </th>
                                            <th
                                                style={{
                                                    width: "15%",
                                                    textAlign: "right",
                                                }}
                                                className="tableCellHeader"
                                            >
                                                Količina
                                            </th>
                                            <th
                                                style={{
                                                    width: "15%",
                                                    textAlign: "right",
                                                }}
                                                className="tableCellHeader"
                                            >
                                                Iznos
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody className="tableRow">
                                        {this.props.oneInvoice.items.map(
                                            (key, index) => (
                                                <tr key={index}>
                                                    <td
                                                        style={{
                                                            width: "50%",
                                                            textAlign: "left",
                                                        }}
                                                        className="tableCell"
                                                    >
                                                        {key.article}
                                                    </td>
                                                    <td
                                                        style={{
                                                            width: "20%",
                                                            textAlign: "right",
                                                        }}
                                                        className="tableCell"
                                                    >
                                                        {Intl.NumberFormat(
                                                            "hr",
                                                            {
                                                                style: "decimal",
                                                                minimumFractionDigits: 2,
                                                            }
                                                        ).format(
                                                            key.single_unit_retail_price
                                                        )}
                                                    </td>
                                                    <td
                                                        style={{
                                                            width: "15%",
                                                            textAlign: "right",
                                                        }}
                                                        className="tableCell"
                                                    >
                                                        {key.quantity}
                                                    </td>
                                                    <td
                                                        style={{
                                                            width: "15%",
                                                            textAlign: "right",
                                                        }}
                                                        className="tableCell"
                                                    >
                                                        {Intl.NumberFormat(
                                                            "hr",
                                                            {
                                                                style: "decimal",
                                                                minimumFractionDigits: 2,
                                                            }
                                                        ).format(
                                                            key.total_amount
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                    <tbody className="tableRow">
                                        <tr>
                                            <td
                                                style={{
                                                    width: "50%",
                                                    textAlign: "left",
                                                }}
                                                className="ukupno"
                                            >
                                                Ukupno(kn):
                                            </td>
                                            <td
                                                style={{
                                                    width: "20%",
                                                    textAlign: "left",
                                                }}
                                                className="ukupno"
                                            ></td>
                                            <td
                                                style={{
                                                    width: "15%",
                                                    textAlign: "left",
                                                }}
                                                className="ukupno"
                                            ></td>
                                            <td
                                                style={{
                                                    width: "15%",
                                                    textAlign: "right",
                                                }}
                                                className="ukupno"
                                            >
                                                {Intl.NumberFormat("hr", {
                                                    style: "decimal",
                                                    minimumFractionDigits: 2,
                                                }).format(
                                                    this.props.oneInvoice
                                                        .invoice_amount
                                                )}{" "}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                {/* porezi */}
                                {this.props.oneInvoice.tax.length > 0 ? (
                                    <table className="table">
                                        <thead className="tableRow">
                                            <tr className="tableRow">
                                                <th
                                                    style={{
                                                        width: "50%",
                                                        textAlign: "left",
                                                    }}
                                                    className="tableCellHeader"
                                                >
                                                    Porez
                                                </th>
                                                <th
                                                    style={{
                                                        width: "25%",
                                                        textAlign: "right",
                                                    }}
                                                    className="tableCellHeader"
                                                >
                                                    Osnovica
                                                </th>
                                                <th
                                                    style={{
                                                        width: "25%",
                                                        textAlign: "right",
                                                    }}
                                                    className="tableCellHeader"
                                                >
                                                    Iznos
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.oneInvoice.tax.map(
                                                (key, index) => (
                                                    <tr
                                                        className="tableRow"
                                                        key={index}
                                                    >
                                                        <td
                                                            style={{
                                                                width: "50%",
                                                                textAlign:
                                                                    "left",
                                                            }}
                                                            className="tableCell"
                                                        >
                                                            PDV({key.tax_rate}%)
                                                        </td>
                                                        <td
                                                            style={{
                                                                width: "25%",
                                                                textAlign:
                                                                    "right",
                                                            }}
                                                            className="tableCell"
                                                        >
                                                            {Intl.NumberFormat(
                                                                "hr",
                                                                {
                                                                    style: "decimal",
                                                                    minimumFractionDigits: 2,
                                                                }
                                                            ).format(
                                                                key.tax_base
                                                            )}
                                                        </td>
                                                        <td
                                                            style={{
                                                                width: "25%",
                                                                textAlign:
                                                                    "right",
                                                            }}
                                                            className="tableCell"
                                                        >
                                                            {Intl.NumberFormat(
                                                                "hr",
                                                                {
                                                                    style: "decimal",
                                                                    minimumFractionDigits: 2,
                                                                }
                                                            ).format(
                                                                key.tax_amount
                                                            )}
                                                        </td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                ) : null}

                                <div style={{ marginBottom: "40px" }} />

                                <div className="text">
                                    ZKI: {this.props.oneInvoice.ZKI}
                                </div>
                                <div className="text">
                                    JIR: {this.props.oneInvoice.JIR}
                                </div>

                                <div style={{ marginBottom: "40px" }} />

                                <div style={{ textAlign: "center" }}>
                                    {this.qrCode(this.props.oneInvoice)}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="form-group" style={{ marginTop: "30px" }}>
                    <div
                        className="btn btn-default"
                        style={{ marginBottom: "10px" }}
                        onClick={this.props.toggleInvoiceVisibility}
                    >
                        <BsBackspaceFill size={30} /> <strong>Nazad</strong>
                    </div>
                    <div
                        className="btn btn-light"
                        style={{ marginBottom: "10px", float: "right" }}
                    >
                        <GrDocumentPdf
                            size={30}
                            onClick={() =>
                                this.saveToPDF(
                                    () =>
                                        this.props.oneInvoice.invoice_no +
                                        "/" +
                                        this.props.oneInvoice
                                            .invoice_business_premises_label +
                                        "/" +
                                        this.props.oneInvoice
                                            .invoice_billing_device_isu
                                )
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Main;
